var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93 11",
    style: {
      enableBackground: "new 0 0 93 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.9,4.5c0,0.3,0,0.7-0.1,1.1l-1,5.2H6.3l0.5-2.7H3.1l-0.5,2.7H0.2l1.2-6C1.9,2.3,3.4,1,5.7,1C8.2,1,9.9,2.1,9.9,4.5  M7.2,6l0.1-0.6c0-0.2,0.1-0.4,0.1-0.6c0-1.1-0.8-1.6-1.8-1.6C4.5,3.2,3.9,3.8,3.7,5L3.5,6H7.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.9,5.9 21.7,10.8 18.9,10.8 16.6,6.5 15.8,10.8 13.4,10.8 15.3,1.2 17.7,1.2 16.9,4.8 20.3,1.2 23.4,1.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,6.4c0-3,2.5-5.5,5.7-5.5C34,1,36,2.7,36,5.5c0,3-2.4,5.5-5.7,5.5C27.6,11,25.6,9.2,25.6,6.4 M33.5,5.6 c0-1.5-1-2.4-2.5-2.4c-1.9,0-3,1.5-3,3.1c0,1.5,1,2.5,2.5,2.5C32.3,8.8,33.5,7.2,33.5,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6,4c0,0.3,0,0.6-0.1,1l-1.1,5.8h-2.4l1.2-6c0-0.1,0.1-0.3,0.1-0.5c0-0.8-0.5-1.1-1.2-1.1c-0.6,0-1.2,0.4-1.4,1.4 l-1.2,6.3H51l1.2-6c0-0.2,0-0.3,0-0.5c0-0.8-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.4-1.3,1.4l-1.2,6.2h-2.4l1.2-6.5C47.8,2,49.2,1,50.9,1 c1.2,0,2.2,0.4,2.7,1.4C54.3,1.4,55.3,1,56.4,1C58.3,1,59.6,2.1,59.6,4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,4.5c0,0.3,0,0.7-0.1,1.1l-1,5.2H69l0.5-2.7h-3.7l-0.5,2.7h-2.4l1.2-6C64.5,2.3,66.1,1,68.4,1 C70.9,1,72.5,2.1,72.5,4.5 M69.9,6L70,5.4c0-0.2,0.1-0.4,0.1-0.6c0-1.1-0.8-1.6-1.8-1.6c-1.1,0-1.7,0.6-1.9,1.8l-0.2,1H69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8,5.4L86.6,7c-0.7,2.4-2.7,4-5.4,4c-2.7,0-4.8-1.8-4.8-4.5c0-3,2.5-5.5,5.7-5.5c2.4,0,4.2,1.4,4.7,3.4h-2.6 c-0.4-0.7-1.2-1.2-2.2-1.2c-1.8,0-3.1,1.5-3.1,3.1c0,1.5,1,2.5,2.6,2.5c1.1,0,2-0.5,2.5-1.4h-3.2V5.4H86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,9.8c0-0.9,0.7-1.6,1.6-1.6c0.8,0,1.3,0.5,1.3,1.3c0,0.9-0.7,1.6-1.5,1.6C90.5,11,89.9,10.5,89.9,9.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec7f0edb449a4d81c500171037fc7eca.svg";
export { ForwardRef as ReactComponent };